import { render, staticRenderFns } from "./ISO.vue?vue&type=template&id=39a53cf6&scoped=true&"
import script from "./ISO.vue?vue&type=script&lang=ts&"
export * from "./ISO.vue?vue&type=script&lang=ts&"
import style0 from "./ISO.vue?vue&type=style&index=0&id=39a53cf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a53cf6",
  null
  
)

export default component.exports